export const TOTAL_SECONDS = 180;

export const SLIDE_META = [
  { key: "cover", label: "Cover", budget: 15 },
  { key: "problem", label: "Problem", budget: 25 },
  { key: "solution", label: "Solution", budget: 25 },
  { key: "product", label: "Product", budget: 35 },
  { key: "impact", label: "Social Impact", budget: 20 },
  { key: "tech", label: "Innovation & Tech", budget: 20 },
  { key: "traction", label: "Traction", budget: 25 },
  { key: "closing", label: "Closing", budget: 15 },
];

export const SLIDE_STARTS = SLIDE_META.reduce(
  (acc, s, i) => [...acc, i === 0 ? 0 : acc[i - 1] + SLIDE_META[i - 1].budget],
  []
);

export const EASE = [0.22, 1, 0.36, 1];

export const slideAt = (elapsed) => {
  let i = 0;
  SLIDE_STARTS.forEach((s, n) => {
    if (elapsed >= s) i = n;
  });
  return i;
};
